export const PhysiotherapyReferralOrigins = {
    Manager: "Manager Referral",
    Self: "Self Referral"
};
